<template>
  <div class="workbench-page">
    <!-- 右侧内容区 -->
    <div class="content-area">
      <!-- 统计卡片行 -->
      <div class="stats-row">
        <div class="stat-card" v-for="(item, index) in statsList" :key="index">
          <div class="stat-icon">
            <img :src="item.icon" alt="" />
          </div>
          <div class="stat-info">
            <div class="stat-value-row">
              <span class="stat-value">{{ item.value }}</span>
              <span class="stat-unit">{{ item.unit }}</span>
            </div>
            <div class="stat-label">{{ item.label }}</div>
          </div>
        </div>
      </div>
       <div class="correlation">
          <div class="report-panel">
            <div class="report-tabs">
              <div class="report-tab" v-for="item in reportList" :key="item.type">
                <span class="report-tab-label" @click="openReport(item, false)">
                  {{ item.label }}
                </span>
                <el-tooltip content="企业信息更新后，点击强制重新生成PDF" placement="top">
                  <i
                    class="el-icon-refresh-right report-refresh"
                    @click="openReport(item, true)"
                  />
                </el-tooltip>
              </div>
            </div>
            <div class="report-hint">
              点击名称在新窗口生成并打开PDF预览；企业信息更新后，点击刷新图标强制重新生成
            </div>
          </div>
        </div>
      <!-- 最近融资 -->
      <div class="recent-finance">
        <div class="section-header">
          <div class="section-title">
            <span class="title-bar" />
            最近融资
          </div>
          <div class="section-more" @click="goAll">
            全部 <i class="el-icon-arrow-right" />
          </div>
        </div>
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width: 65px;">序号</th>
                <th style="width: 131px;">贷款名称</th>
                <th style="width: 131px;">贷款额度</th>
                <th style="width: 131px;">贷款期限</th>
                <th style="width: 131px;">年利率范围</th>
                <th style="width: 131px;">担保方式</th>
                <th style="width: 131px;">信贷类型</th>
                <th style="width: 150px;">客户经理</th>
                <th style="width: 131px;">联系电话</th>
                <th>产品描述</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in tableData" :key="row.id || idx">
                <td>{{ idx + 1 }}</td>
                <td>{{ row.cpmc }}</td>
                <td>{{ row.dkedxx }} ~ {{ row.dkedsx }}万元</td>
                <td>{{ row.dkqxxx }} ~ {{ row.dkqxsx }}月</td>
                <td>{{ row.zdnhlv }}% ~ {{ row.zgnhlv }}%</td>
                <td>{{ row.dbfsm }}</td>
                <td>{{ row.dklxm }}</td>
                <td>{{ row.khjl }}</td>
                <td>{{ row.lxrdh }}</td>
                <td>
                  <el-popover placement="top-start" width="260" trigger="hover">
                    <div class="table-popover custom-scrollbar" v-html="row.cpms" />
                    <div slot="reference" class="table-text">{{ row.cpms }}</div>
                  </el-popover>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* 图片导入 */
import statProduct from "@/assets/img/2026/bar-3.png";
import statEnterprise from "@/assets/img/2026/bar-2.png";
import statAmount from "@/assets/img/2026/bar-6.png";
/* API 导入 */
import {
  getFinancialProduct,
  getProductOrderList,
  getBasicsExport,
  getDetailsExport,
} from "./viewApi";

export default {
  name: "workbench",
  data() {
    return {
      activeMenu: "workbench",
      tableData: [],
      productCount: 0,
      sumMoney: 0,
      enterpriseCount: 0,
      statsList: [],
      // 信用报告入口：点击后新窗口生成并预览PDF
      reportList: [
        { type: "base", label: "企业征信报告基础版pdf预览及下载" },
        { type: "detail", label: "企业征信报告详细版pdf预览及下载" },
      ],
    };
  },
  created() {
    this.getData();
    this.getList();
  },
  mounted() {
    this.buildStatsList();
  },
  methods: {
    /** 获取统计数据 */
    async getData() {
      const res = await getFinancialProduct();
      this.sumMoney = res.data.sumMoney;
      this.productCount = res.data.productSumCount;
      this.enterpriseCount = res.data.productCount;
      this.buildStatsList();
    },

    /** 构建统计列表 */
    buildStatsList() {
      this.statsList = [
        { icon: statProduct, value: this.productCount || 0, unit: "个", label: "审请产品个数" },
        { icon: statEnterprise, value: this.sumMoney || 0, unit: "万元", label: "累计撮合金额" },

        { icon: statAmount, value: this.enterpriseCount || 0, unit: "笔", label: "累计成交笔数" },
      ];
    },

    /** 获取最近融资列表 */
    async getList() {
      const res = await getProductOrderList();
      this.tableData = res.data.records;
    },

    /** 跳转全部 */
    goAll() {
      this.$router.push({ path: "/workbench/trading" });
    },
        /** 打开信用报告：新窗口先显示生成提示，转换完成后自动跳转为PDF预览 */
    async openReport(item, refresh) {
      // 同步打开空窗口并写入加载提示，避免 await 后 window.open 被浏览器拦截
      const win = window.open("", "_blank");
      if (win) {
        win.document.write(this.reportLoadingHtml());
        win.document.close();
      }
      try {
        const params = refresh ? { refresh: true } : {};
        const res =
          item.type === "detail" ? await getDetailsExport(params) : await getBasicsExport(params);
        const url = res && res.data;
        if (!url) {
          win && win.close();
          this.$message.warning("暂无导出数据");
          return;
        }
        const fullUrl = /^https?:\/\//i.test(url) ? url : process.env.VUE_APP_IMG_API + url;
        if (win) {
          // 新窗口由加载页跳转为PDF预览，浏览器自带工具栏可下载
          win.location.href = fullUrl;
        } else {
          window.open(fullUrl, "_blank");
        }
      } catch (e) {
        // 失败原因由request拦截器统一提示，这里把新窗口的加载页换成失败提示
        if (win) {
          win.document.body.innerHTML =
            '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;color:#909399;font-size:15px;">' +
            '<div style="font-size:40px;margin-bottom:12px;">&#10060;</div>报告生成失败，请稍后重试</div>';
          setTimeout(() => {
            win.close();
          }, 3000);
        }
      }
    },

    /** 新窗口的加载提示页（内联样式，不依赖应用CSS） */
    reportLoadingHtml() {
      return (
        '<!DOCTYPE html><html><head><meta charset="utf-8"><title>报告生成中</title></head>' +
        '<body style="margin:0"><div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;background:#f5f7fa;">' +
        '<div style="width:42px;height:42px;border:4px solid #e4eaf5;border-top-color:#1366ec;border-radius:50%;animation:reportSpin 0.9s linear infinite;"></div>' +
        '<p style="margin-top:18px;font-size:15px;color:#303133;font-weight:600;">正在生成报告…</p>' +
        '<p style="margin-top:6px;font-size:13px;color:#909399;">首次生成需要一点时间，请稍候，生成完成后将自动打开PDF</p>' +
        '<style>@keyframes reportSpin{to{transform:rotate(360deg)}}</style>' +
        "</div></body></html>"
      );
    },
  },
};
</script>

<style scoped lang="scss">
.workbench-page {
  display: flex;
  min-height: calc(100vh - 70px);
  // background: #ffffff;
}

/* 左侧菜单 */
.sidebar {
  width: 200px;
  flex-shrink: 0;
  padding: 45px 0;
  display: flex;
  flex-direction: column;
  gap: 21px;
}

.menu-item {
  width: 200px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  border-radius: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  padding: 12px 0;

  i {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.4);
  }

  &:hover {
    background: rgba(19, 102, 236, 0.04);
  }

  &.active {
    background: #ffffff;
    color: #1366ec;
    border-bottom-color: rgba(0, 0, 0, 0.1);
  }
}

/* 右侧内容区 */
.content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 统计卡片行 */
.stats-row {
  display: flex;
  background: #ffffff;
  border-radius: 16px;
}

.stat-card {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 6px 12px;
}

.stat-icon {
  width: 98px;
  height: 98px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: #d9d9d9;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.stat-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.stat-value-row {
  display: flex;
  align-items: flex-end;
  gap: 2px;
}

.stat-value {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 36px;
  line-height: 20px;
  color: #1366ec;
}

.stat-unit {
  font-family: "Noto Sans SC", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.5);
}

.stat-label {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.9);
}

/* 最近融资 */
.recent-finance {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 5px 5px 0 rgba(54, 97, 167, 0.05);
  // margin: 0 20px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 7px;
}

.title-bar {
  width: 5px;
  height: 16px;
  background: #1366ec;
  border-radius: 16px;
}

.section-title span:last-child {
  font-family: "PingFang SC", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
}

.section-more {
  font-family: "Noto Sans SC", sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #1366ec;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 2px;

  i {
    font-size: 14px;
  }

  &:hover {
    opacity: 0.8;
  }
}

/* 自定义表格 */
.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead th {
    background: #F8F8FA;
    border: 1px solid #e5e5e5;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px 10px;
    font-family: "PingFang SC", sans-serif;
    font-weight: 600;
    font-size: 14px;
    color: #909399;
    text-align: center;
    white-space: nowrap;
  }

  tbody td {
    border: 1px solid #e5e5e5;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px 10px;
    font-family: "PingFang SC", sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    text-align: center;
  }
}

.table-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 120px;
  cursor: pointer;
  display: inline-block;
}

.table-popover {
  max-height: 200px;
  overflow-y: auto;
  font-size: 13px;
  line-height: 1.6;
  color: #606266;
}
    .report-panel {
      background: #ffffff;
      border-radius: 16px;
      padding: 20px;
      box-shadow: 0 5px 5px 0 rgba(54, 97, 167, 0.05);

      .report-tabs {
        display: flex;
        gap: 16px;
        margin-bottom: 16px;

        .report-tab {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          text-align: center;
          padding: 12px 10px;
          font-size: 14px;
          font-weight: 500;
          color: #606266;
          background: #f5f7fa;
          border: 1px solid transparent;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            color: #1366ec;
          }

          .report-refresh {
            font-size: 14px;
            color: #1366ec;

            &:hover {
              transform: rotate(180deg);
              transition: transform 0.3s;
            }
          }
        }
      }

      .report-hint {
        text-align: center;
        font-size: 13px;
        color: #909399;
        padding: 4px 0 2px;
      }
    }
</style>
